import React from 'react';
import Image from '../../assets/About/main.png';
import './Main.css';
import Fade from 'react-reveal/Fade';
import { Dimensions } from '../../Helper/sitedimension';

const main = () => {
    const { width } = Dimensions.useWindowDimensions();
    return (
        <div className="main">
            {width > 500 ?
                <div className="container-fluid bg-1">
                    <h3 className="title">
                        <Fade delay={300}>
                            <span className="con1">How The </span>
                            <span className="con2">Company started ?</span>
                        </Fade>
                    </h3>
                    <Fade delay={600}>
                        <img className="image" src={Image} alt="contact" />
                    </Fade>
                </div> :
                <div className="container-fluid ab">
                    <h3 className="titleab">
                        <Fade delay={300}>
                            <span className="con1">How The </span>
                            <span className="con2">Company started ?</span>
                        </Fade>
                    </h3>
                    <Fade delay={600}>
                        <img className="imageab" src={Image} alt="contact" />
                    </Fade>
                </div>
            }
        </div>
    )
}

export default main;